<script>
import {mapActions, mapState} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import EverywhereListItem from "@/components/MainSearch/SearchResult/EverywhereListItem.vue";


export default {
  name: "EverywhereList",
  components: {
    EverywhereListItem
  },
  computed: {
    ...mapState(mainSearchStore, [
      'searchAllResult'
    ]),
    sortedResulList() {
      return  this.searchAllResult.sort((a, b) => { // eslint-disable-line
        return b.result.length - a.result.length;
      })
    }
  },
  methods: {
    ...mapActions(mainSearchStore, [
      'runSearch'
    ])
  },
  mounted() {
    this.runSearch();
  }
}
</script>

<template>
  <div>
    <everywhere-list-item v-for="list in sortedResulList"
                          :key="list.type"
                          :type="list.type"
    />
  </div>
</template>